import Lottie from "lottie-react";
import congratulations from "../../../../assets/lottie/congratulations.json";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../core/auth";

const SignupComplete = () => {
  const { logoutAdmin } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-6">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 space-y-6 text-center">
        <div className="w-full h-full mx-auto">
          <Lottie animationData={congratulations} loop={true} />
        </div>

        <div className="space-y-4">
          <h1 className="text-2xl font-bold text-gray-800">
            입점 신청이 완료되었습니다! 🎉
          </h1>
          <p className="text-gray-600">마감히어로와 함께해 주셔서 감사합니다</p>
          <p className="text-gray-600 text-sm">
            입력하신 매장 정보는 입점 후 모두 수정 가능합니다.
          </p>
        </div>

        <div className="bg-blue-50 rounded-lg p-4 text-left space-y-2">
          <ul className="text-base text-blue-700 space-y-1">
            <li>
              • <span className="font-bold text-rose-400">24시간 이내</span>로
              입점 신청을 검토해드릴게요.
            </li>
            <li>
              • 승인이 완료되면{" "}
              <span className="font-medium text-rose-500">카카오톡</span>
              으로 안내드릴게요.
            </li>
          </ul>
        </div>

        <button
          onClick={() => {
            localStorage.removeItem("sellerToken");
            logoutAdmin();
            navigate("/");
            window.location.reload();
          }}
          className="w-full py-3 bg-blue-500 text-white rounded-lg font-semibold hover:bg-blue-600 transition-colors"
        >
          홈으로 돌아가기
        </button>
      </div>
    </div>
  );
};

export default SignupComplete;
